var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-form',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"schema":_vm.schema,"storeNamespace":"clients","objectNamespace":"O_client","sectionTitles":_vm.sectionTitles,"columnLayout":6,"objectId":_vm.id,"listOnSave":false}})}
var staticRenderFns = []

export { render, staticRenderFns }